import { observer } from 'mobx-react-lite'
import { SelectField } from 'shared/ui/Select/SelectField/SelectField'
import { EnumDropdownItemVariant, Icon, type IDropdownItem, Typography } from 'shared/ui'
import { type IResponseInbox } from 'entities/Inbox/api/types'
import { type AssignNumberCommonStore } from 'entities/Phone'
import { NextButton } from '../NextButton/NextButton'
import styles from './styles.module.scss'

type IExistingInboxContentProps = {
  store: AssignNumberCommonStore
}

export const ExistingInboxContent = observer(({ store }: IExistingInboxContentProps) => {
  const {
    activeInboxId,
    activeInbox,
    allTeamInboxes,
    setActiveInbox,
    nextClick,
    hideSubmit,
    disabledButton,
    loadingButton,
    loadingFetchAllInboxes,
  } = store

  const items: IDropdownItem[] = allTeamInboxes.map((item) => ({
    id: item.id,
    label: item.name,
    value: item.name,
    data: item,
    variant: EnumDropdownItemVariant.Custom,
    height: '51px',
    className: styles.option,
    renderOption: (option) => {
      const { numbers, number, name } = option.data as IResponseInbox

      return (
        <div className={styles.optionWrap}>
          <Icon
            insideBox
            padding={8}
            className={styles.optionWrap__icon}
            icon={number?.is_aircall ? 'aircall' : 'inbox'}
            fontSize={16}
            color='var(--content-primary-tertiary)'
          />

          <div className={styles.optionWrap__info}>
            <Typography
              ariaLabel='name'
              color='var(--content-primary-primary)'
              variant='body-md-regular'
              width={350}
              ellipsis
            >
              {name}
            </Typography>
            <Typography
              ariaLabel='phone'
              color='var(--content-primary-tertiary)'
              variant='body-sm-regular'
            >
              {numbers.length === 1 ? numbers[0].formattedNumber : `${numbers.length} numbers`}
            </Typography>
          </div>
        </div>
      )
    },
  }))
  return (
    <div>
      <SelectField
        setValue={setActiveInbox}
        value={activeInboxId}
        labelText='Inbox'
        items={items}
        loading={loadingFetchAllInboxes}
        btnProps={{
          size: 'extraLarge',
          placeholder: 'Select',
          text: activeInboxId ? (
            <Typography ariaLabel='name' variant='body-md-regular' ellipsis width={350}>
              {activeInbox?.name}
            </Typography>
          ) : (
            'Select'
          ),
          textIcon: activeInboxId ? 'inboxOpen' : undefined,
          textIconColor: 'var(--content-primary-tertiary)',
        }}
      />

      {!hideSubmit && (
        <NextButton
          text='Next'
          disabled={disabledButton}
          loading={loadingButton}
          onClick={() => nextClick()}
        />
      )}
    </div>
  )
})
